export interface IFavorite {
    ocorrenciaNo: number;
    codigo: any;
    titulo: any;
    habilitado: boolean;
    pessoa: string;
    usuario: string;
    data: Date;
}
